import React from 'react'
import { Helmet } from 'react-helmet'
import * as Context from '../components/context'

export class PageHeader extends React.Component {

  render() {
    return (
      <div className="application">
				<Context.Template.Consumer>
					{ context => (
						<Helmet>
							<title>2020 Year in Review {context.pageTitle ? `: ${context.pageTitle}`: ''}</title>
						</Helmet>
					)}
				</Context.Template.Consumer>
      </div>
    )
  }
}